export default "__VITE_ASSET__BUU9i6pE__"